import * as yup from 'yup';

// Schema exclusivo del registro público de hoteles. Extiende los campos
// base del hotel y exige además los datos de la persona encargada (captura
// de lead). Se mantiene aparte de `hotelSchema` para no forzar estos campos
// en los formularios de edición de hoteles ya existentes en producción.
export const hotelRegisterSchema = yup.object().shape({
  email: yup.string().email('El correo electrónico debe ser válido').required('El correo electrónico es obligatorio'),
  password: yup.string().min(6, 'La contraseña debe tener al menos 6 caracteres').required('La contraseña es obligatoria'),
  name: yup.string().required('El nombre del hotel es obligatorio'),
  managerName: yup.string().required('El nombre de la persona encargada es obligatorio'),
  managerPhone: yup.string().required('El teléfono de la persona encargada es obligatorio'),
  contact: yup.string().required('El número de contacto es obligatorio'),
  address: yup.string().required('La dirección es obligatoria'),
  country: yup.string().required('El país es obligatorio'),
  currency: yup.string().required('La moneda es obligatoria'),
  timezone: yup.string().required('La zona horaria es obligatoria')
});
